import Layout from "./Layout.vue";
import Container from "./Container.vue";
import Breadcrumbs from "./Breadcrumbs.vue";
import FormGroup from "./FormGroup.vue";
import Header from "./Header.vue";
import Card from "./Card.vue";
import CardRow from "./CardRow.vue";
import DataTable from "./DataTable.vue";
import LeaveImpersonationButton from "./LeaveImpersonationButton";
import Sheet from "./Sheet.vue";

import BoolIcon from "./BoolIcon.vue";
import Stamp from "./Stamp.vue";
import Chip from "./Chip.vue";

import ButtonFill from "./ButtonFill.vue";
import Delete from "./Delete.vue";
import Remove from "./Remove.vue";
import PreviousBtn from "./Previous.vue";
import Slider from "./Slider.vue";
import BaseDescription from "./BaseDescription.vue";
import BaseDescriptionItem from "./BaseDescriptionItem.vue";
import BaseNotification from "./BaseNotification.vue";

export default {
  install(Vue) {
    Vue.component("d-layout", Layout);
    Vue.component("d-container", Container);
    Vue.component("d-header", Header);
    Vue.component("d-breadcrumbs", Breadcrumbs);
    Vue.component("d-form-group", FormGroup);
    Vue.component("d-card", Card);
    Vue.component("d-card-row", CardRow);
    Vue.component("d-data-table", DataTable);
    Vue.component("d-leave-impersonation", LeaveImpersonationButton);
    Vue.component("d-sheet", Sheet);
    Vue.component("d-slider", Slider);
    Vue.component("d-bool-icon", BoolIcon);
    Vue.component("d-stamp", Stamp);
    Vue.component("d-chip", Chip);

    Vue.component("d-button-fill", ButtonFill);
    Vue.component("d-delete", Delete);
    Vue.component("d-remove", Remove);
    Vue.component("d-previous-btn", PreviousBtn);

    Vue.component("d-description", BaseDescription);
    Vue.component("d-description-item", BaseDescriptionItem);
    Vue.component("d-notification", BaseNotification);
  }
};
